'use client'

import { ErrorPage } from 'components/error.page'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function NotFound() {
  const { t } = useTranslation()

  return (
    <ErrorPage
      code={404}
      title={t('404-error-title', 'Lost in Material')}
      text={t('404-error-text', 'Oops it looks like there was an error opening this page. Please check the URL or go back home.')}
      gotoHome={true}
    />
  )
}
